const angular = require('angular')
const isEmpty = require('lodash/isEmpty')

module.exports = [
  '$utils',
  '$location',
  '$translate',
  '$q',
  'Message',
  'StorageMailFolder',
  'SearchMailFolder',
  'User',
  'KeywordSearchMail',
  'MailDealingFolder',
  'MailFolderType',
  'globalFolderService',
  function ($utils, $location, $translate, $q, Message, StorageMailFolder,
    SearchMailFolder, User, KeywordSearchMail, MailDealingFolder, MailFolderType, globalFolderService) {
    const mailDealingFolderList = []
    let allFolderInstances = null
    const topFolderIds = [
      MailFolderType.VIP,
      MailFolderType.UNREAD,
      MailFolderType.MAIL,
      MailFolderType.DEFERRED,
      MailFolderType.FLAGGED,
      MailFolderType.DRAFT,
      MailFolderType.SENT
    ]
    let otherFolderIds = null
    const virtualFolderIds = [
      MailFolderType.VIP,
      MailFolderType.DEFERRED,
      MailFolderType.FLAGGED,
      MailFolderType.UNREAD,
    ]

    // 虚拟文件夹 如重要邮件、未读邮件
    const virtualFolders = {}
    virtualFolders[MailFolderType.VIP] = new SearchMailFolder(MailFolderType.VIP, 'receivedDate', { flags: { vip: true } })
    virtualFolders[MailFolderType.DEFERRED] = new SearchMailFolder(MailFolderType.DEFERRED, 'deferredDate', { flags: { deferHandle: true } })
    virtualFolders[MailFolderType.FLAGGED] = new SearchMailFolder(MailFolderType.FLAGGED, 'receivedDate', { flags: { flagged: true } })
    virtualFolders[MailFolderType.UNREAD] = new SearchMailFolder(MailFolderType.UNREAD, 'receivedDate', { flags: { read: false } })

    // 获取实体文件夹数据，若网络不可用等导致的接口调用失败则使用缓存的文件夹数据
    function getAllFolders(mboxa) {
      return globalFolderService.getAllFolders(mboxa).then(res => {
        allFolderInstances = createAllStorageMailFolder(res)
        allFolderInstances = angular.extend(allFolderInstances, virtualFolders)
        otherFolderIds = getOtherFolderIds(res)
        return res
      })
    }
    // 计算其他文件夹的id列表
    function getOtherFolderIds(folderList) {
      const temp = []
      if (folderList) {
        folderList.forEach(function (folder) {
          !~topFolderIds.indexOf(folder.id) && temp.push(folder.id)
        })
      }
      return temp
    }
    // 创建文件夹实例对象
    function createAllStorageMailFolder(folderInfoList) {
      const allFolderInstances = {}
      getAllFolderInstance(folderInfoList, allFolderInstances, false)
      return allFolderInstances
    }
    // 递归创建文件夹实例森林（多棵互不相交的树的集合）
    function getAllFolderInstance(folderInfoList, instancesMap, parent) {
      folderInfoList.forEach(function (folder) {
        const folderInstance = new StorageMailFolder(folder)
        instancesMap[folder.id.toString()] = folderInstance
        parent && parent.children.push(folderInstance)
        if (folder.children && folder.children.length > 0) {
          folderInstance.children = []
          getAllFolderInstance(folder.children, instancesMap, folderInstance)
        }
      })
    }
    // 获取指定文件夹实例
    const getFolder = function (fid, mboxa) {
      const deferred = $q.defer()
      fid = fid || 1

      if (fid != 0) {
        if (!allFolderInstances) {
          getAllFolders(mboxa).then(function () {
            deferred.resolve(allFolderInstances[fid.toString()])
          }, function (error) {
            deferred.reject(error)
          })
        } else {
          deferred.resolve(allFolderInstances[fid.toString()])
        }
      } else {
        throw 'FOLDER_ID_INVALID' //eslint-disable-line
      }

      return deferred.promise
    }
    // 文件夹过滤
    function filterFolders(fids, allFolderInstances) {
      const result = []
      fids.forEach(function (fid) {
        allFolderInstances[fid] && result.push(allFolderInstances[fid])
      })
      return result
    }
    // 包装文件夹
    function folderWrapper(folder, parentWrapper) {
      const wrappedFolder = { data: folder, isWrapped: true }
      if (parentWrapper) {
        parentWrapper.children.push(wrappedFolder)
      }

      if (folder.children && folder.children.length > 0) {
        wrappedFolder.children = []
        for (let i = 0; i < folder.children.length; ++i) {
          folderWrapper(folder.children[i], wrappedFolder)
        }
      }
      return wrappedFolder
    }
    // 获取虚拟文件夹的统计信息
    let allFolderInstancesStats = {}
    function getAllVirtualFoldersStats(mboxa) {
      const deferred = $q.defer()
      const promises = []
      virtualFolderIds.forEach(function (fid) {
        promises.push(getVirtualFoldersStats(virtualFolders[fid].filter.flags, fid, mboxa))
      })
      $q.all(promises).then(function (data) {
        deferred.resolve()
      }, function (error) {
        console.log(error)
        deferred.reject()
      })
      return deferred.promise
    }
    // 获取指定虚拟文件夹的统计信息
    function getVirtualFoldersStats(flag, fid, mboxa) {
      const deferred = $q.defer()
      globalFolderService.getFolderStatsInfo(fid, mboxa).then(function (data) {
        allFolderInstancesStats[fid] = data
        deferred.resolve()
      }, function () {
      })
      return deferred.promise
    }
    // 获取实体文件夹的统计信息
    function getAllRealFoldersStats(mboxa) {
      const deferred = $q.defer()
      globalFolderService.getAllFolders(mboxa).then(function (data) {
        recursiveFolderStats(data)
        deferred.resolve()
      }, function () {
        deferred.reject()
      })
      return deferred.promise
    }
    // 获取所有实体文件夹stats信息的map对象
    function recursiveFolderStats(folderInfoList) {
      folderInfoList.forEach(function(folder) {
        allFolderInstancesStats[folder.id] = folder.stats
        if (folder.children && folder.children.length !== 0) {
          recursiveFolderStats(folder.children)
        }
      })
    }
    // 刷新文件夹统计信息stats
    function refreshFolderStats(mboxa) {
      const deferred = $q.defer()
      if (mboxa === undefined) mboxa = User.getSelectedAccountSymbol()
      if (folders.mboxa !== mboxa) {
        // mboxa不同则不刷新文件夹统计信息
        deferred.resolve()
      } else {
        allFolderInstancesStats = {}
        getAllRealFoldersStats(mboxa).then(function () {
          getAllVirtualFoldersStats(mboxa).then(function () {
            Object.keys(allFolderInstancesStats).forEach(function (fid) {
              allFolderInstances[fid]['stats'] = allFolderInstancesStats[fid]
            })
            deferred.resolve()
          })
        }, function () {
          deferred.reject()
        })
      }
      return deferred.promise
    }
    // 添加虚拟文件夹标志
    const folders = {
      topFolders: [],
      otherFolders: [],
      realFolderIds: [],
      loaded: false,
      mboxa: ''
    }
    // 列出所有文件夹
    function listFolders(mboxa) {
      const deferred = $q.defer()
      if (mboxa === undefined) mboxa = User.getSelectedAccountSymbol()
      if (folders.mboxa !== mboxa) {
        folders.loaded = false
      }
      if (folders.loaded) {
        deferred.resolve(folders)
      } else {
        clearFolders()
        getAllFolders(mboxa).then(function () {
          getTopFolders(mboxa).then(function (topFolders) {
            topFolders.forEach(function (topFolder) {
              folders.topFolders.push(folderWrapper(topFolder))
            })
            getOtherFolders(mboxa).then(function (otherFolders) {
              otherFolders.forEach(function (otherFolder) {
                folders.otherFolders.push(folderWrapper(otherFolder))
              })
              folders.loaded = true
              folders.mboxa = mboxa
              deferred.resolve(folders)
            })
          }, function () {
          })
        }, function () {
        })
      }
      return deferred.promise
    }

    /**
     * 获取优先排列在文件夹列表的头部的文件
     * @returns {*}
     */
    function getTopFolders(mboxa) {
      const deferred = $q.defer()
      if (allFolderInstances) {
        deferred.resolve(filterFolders(topFolderIds, allFolderInstances))
      } else {
        getAllFolders(mboxa).then(function () {
          deferred.resolve(filterFolders(topFolderIds, allFolderInstances))
        }, function () {
          deferred.reject([])
        })
      }
      return deferred.promise
    }

    /**
     * 获取剩余的文件夹
     * @returns {*}
     */
    function getOtherFolders(mboxa) {
      const deferred = $q.defer()
      if (allFolderInstances) {
        deferred.resolve(filterFolders(otherFolderIds, allFolderInstances, false))
      } else {
        getAllFolders(mboxa).then(function () {
          deferred.resolve(filterFolders(otherFolderIds, allFolderInstances, false))
        }, function () {
          deferred.reject([])
        })
      }
      return deferred.promise
    }
    // 清楚所有文件夹实例缓存
    const clearFolders = function () {
      allFolderInstances = null
      folders.topFolders = []
      folders.otherFolders = []
      folders.realFolderIds = []
      folders.loaded = false
      folders.mboxa = ''
    }
    // 解锁所有文件夹
    const unlockAllFolders = function () {
      Object.keys(allFolderInstances).forEach(function (fid) {
        allFolderInstances[fid].auth2Locked && (allFolderInstances[fid].auth2Locked = false)
      })
    }

    /** 将搜索列表当作特殊的文件夹
     *  @param {string} keyword 搜索关键字
     *  @param {boolean} refresh 是否重新搜索
     *  @param {string} mboxa 共享邮箱账号标识
     * */
    const mailSearchFolder = {}
    function getSearchFolder({searchField, keyword, refresh, isMailDealing, mboxa}) {
      const user = User.getCurrentUser()
      const userEmail = user.config.email || ''
      const searchFolderKey = userEmail + ':' + keyword + (isMailDealing ? ':mailDealings' : '') + ':' + searchField + (mboxa ? `:${mboxa}` : '')
      if (refresh || isEmpty(mailSearchFolder[searchFolderKey])) {
        mailSearchFolder[[searchFolderKey]] = isMailDealing ? new KeywordSearchMail('', keyword) : new KeywordSearchMail(searchField, keyword)
      }

      $translate(isMailDealing ? 'OP.MAIL_DEALINGS' : 'MAIL.FOLDER.KEYWORD_SEARCH').then(function (name) {
        mailSearchFolder[searchFolderKey].name = name
      })
      mailSearchFolder[searchFolderKey].mboxa = mboxa

      return mailSearchFolder[searchFolderKey]
    }
    // 获取往来邮件文件夹对象实例
    function getMailDealingFolder(dealingEmail) {
      const user = User.getCurrentUser()
      const userEmail = user.config.email || ''
      const mailDealingFolderKey = 'mailDealing:' + userEmail + '_' + dealingEmail
      if (mailDealingFolderList[mailDealingFolderKey]) {
        return mailDealingFolderList[mailDealingFolderKey]
      } else {
        mailDealingFolderList[mailDealingFolderKey] = new MailDealingFolder(dealingEmail)
        return mailDealingFolderList[mailDealingFolderKey]
      }
    }

    const updateMailsById = function (messageItem) {
      for (const index in allFolderInstances) {
        updateFolder(allFolderInstances[index], messageItem)
      }
    }
    function updateFolder(folder, messageItem) {
      if (folder.messages && folder.messages.length > 0) {
        for (let i = 0; i < folder.messages.length; i++) {
          if (folder.messages[i].messageInfo.id === messageItem.messageInfo.id) {
            angular.extend(folder.messages[i], messageItem)
          }
        }
      }
      // 递归调用更新子目录
      if (folder.children && folder.children.length > 0) {
        for (let j = 0; j < folder.children.length; j++) {
          updateFolder(folder.children[j], messageItem)
        }
      }
    }

    return {
      'getFolder': getFolder,
      'listFolders': listFolders,
      'clearFolders': clearFolders,
      'unlockAllFolders': unlockAllFolders,
      'getSearchFolder': getSearchFolder,
      'updateMailsById': updateMailsById,
      'getMailDealingFolder': getMailDealingFolder,
      'refreshFolderStats': refreshFolderStats
    }
  }]



// WEBPACK FOOTER //
// ./src/js/mail/mailFolderService.js